import React from 'react';
import { connect } from 'react-redux';
import * as actions from './actions';
import QuantityPicker from 'shared/components/ui/quantityPicker';
import CartItemEngraving from './engraving';
import { engravingForItem } from 'shared/models/cart';
import Text from 'components/ui/text';
import PromoIcon from 'images/icons/promo-outline-black.svg?react-svg';

let CartItemList = class CartItemList extends React.Component {
  remove(item) {
    const checkout = this.props.checkout;
    this.props.remove(item, { checkout });
  }

  updateQty(item, qty) {
    const checkout = this.props.checkout;
    if (qty) this.props.updateQty(item, qty, { checkout });
  }

  updateEngraving(item, engraving) {
    const checkout = this.props.checkout;
    return this.props.updateEngraving(item, engraving, { checkout });
  }

  removeEngraving(engraving) {
    const checkout = this.props.checkout;
    return this.props.removeEngraving(engraving, { checkout });
  }

  render() {
    const listClassName =
      'cart-list' + (this.props.className ? ` ${this.props.className}` : '');

    return this.props.products.length ? (
      <ul className={listClassName}>
        {this.props.products.map(item => {
          const engraving = engravingForItem(this.props.engravings, item);
          return (
            <li
              className={
                'cart-item' + (!item.price ? ' cart-item--unavailable' : '')
              }
              key={
                item.cart_id ? item.cart_id + item.qty : item.sku_id + item.qty
              }
            >
              <div className="row">
                <div className="col-xs-9">
                  <img
                    src={item.image}
                    onClick={() => this.props.onClick(item)}
                    className="left cart-item__thumbnail"
                  />
                  <div
                    className="text-bold cart-item__title text-overflow"
                    onClick={() => this.props.onClick(item)}
                  >
                    {item.title}
                  </div>
                  <div className="text-overflow">{item.subtitle}</div>
                  <div>{item.volume}</div>
                  <div>
                    <span
                      className="link-text"
                      onClick={e => this.remove(item, e)}
                    >
                      Remove
                    </span>
                  </div>
                </div>
                <div className="col-xs-3 text-right">
                  <QuantityPicker
                    className="cart-item__qty-input"
                    value={item.qty}
                    min={1}
                    onChange={qty => this.updateQty(item, qty)}
                    disabled={!item.price}
                  />

                  {item.originalSubtotal > item.subtotal ? (
                    <div className="cart-item__discount-container">
                      <Text success className="cart-item__price">
                        <div className="inline-block promo-icon">
                          <PromoIcon />
                        </div>
                        ${item.subtotal.toFixed(2)}
                      </Text>
                      <div className="cart-item__price strikethrough">
                        ${item.originalSubtotal.toFixed(2)}
                      </div>
                    </div>
                  ) : (
                    <div className="cart-item__price">
                      {item.subtotal
                        ? '$' + item.subtotal.toFixed(2)
                        : 'Unavailable'}
                    </div>
                  )}
                </div>
              </div>

              {!!engraving && (
                <CartItemEngraving
                  item={item}
                  engraving={engraving}
                  updateEngraving={engraving =>
                    this.updateEngraving(item, engraving)}
                  removeEngraving={engraving => this.removeEngraving(engraving)}
                  disabled={this.props.loading}
                  checkout={this.props.checkout}
                />
              )}
            </li>
          );
        })}
      </ul>
    ) : (
      <div className={this.props.className}>
        <div className="cart-empty-state">
          <blockquote className="cart-empty-state__block">
            <p className="quote-text cart-empty-state__quote">
              The problem with the world is that everyone is a few drinks
              behind.
            </p>
            <footer className="cart-empty-state__attribution">
              - Humphrey Bogart
            </footer>
          </blockquote>
        </div>
      </div>
    );
  }
};

CartItemList.defaultProps = {
  onClick: () => {}
};

CartItemList = connect(
  state => ({
    ...state.cart,
    address: state.address
  }),
  { ...actions }
)(CartItemList);

export default CartItemList;



// WEBPACK FOOTER //
// ./shared/components/cart/list.js